import { useState } from 'react';

import { DocumentList } from './components/DocumentList';
import { DocumentViewer } from './components/DocumentViewer';
import { Document } from './types';
import { useFetchCreditCardDocumentsMetadata } from './useCreditCardDocumentsMetadata';

export const DocumentSigningView = ({
    initialSelectedDocument = null
}: { initialSelectedDocument?: Document | null } = {}) => {
    const { documents } = useFetchCreditCardDocumentsMetadata();

    const [selectedDocument, setSelectedDocument] = useState<Document | null>(
        initialSelectedDocument
    );

    return (
        <div>
            {!selectedDocument && (
                <DocumentList
                    documents={documents!}
                    setSelectedDocument={setSelectedDocument}
                />
            )}

            {selectedDocument && (
                <DocumentViewer
                    document={selectedDocument}
                    setSelectedDocument={setSelectedDocument}
                />
            )}
        </div>
    );
};
